export default {
    side_options: ["L", "R", "B", "X"]
}